import { BulletPointRow, Col, Row, Text } from '@bridebook/ui';
import styles from '@bridebook/ui/src/components/pricing-accordion/included-in-pricing.style';

interface IProps {
  items: string[];
  includedInPricingTitle: string;
}

const IncludedInPricing = ({ items, includedInPricingTitle }: IProps) => (
  <>
    <Text style={styles.header}>{includedInPricingTitle}</Text>
    <Row style={styles.wrapper}>
      {items.map((item) => (
        <Col xs={12} md={6} style={styles.labelWrap} key={item}>
          <BulletPointRow text={item} />
        </Col>
      ))}
    </Row>
  </>
);

export default IncludedInPricing;
